module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_intro02-61e18bb67ce2c7c78372b5c5493156c0.jpg";